import { Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerProps, DrawerTitle } from '@leadsnavi/ui-kit';
import { CSSProperties, PropsWithChildren } from 'react';
import CloseIcon from '@/assets/icons/close.svg?react';

export type BaseDrawerProps = Pick<DrawerProps, 'open' | 'onOpenChange'> & {
  title?: React.ReactNode;
};
/**
 * 简单针对 Drawer 组件的封装，减少样板代码，如需要增加新的props，可直接在 BaseDrawerProps 中添加
 * @param props
 * @returns
 */
export const BaseDrawer: React.FC<PropsWithChildren<BaseDrawerProps>> = props => {
  const { open, onOpenChange, title, children } = props;
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="max-w-[950px]! w-[950px]!">
        <DrawerHeader className="flex flex-row! h-15 py-4  items-center justify-between">
          <DrawerTitle className=" m-0">{title}</DrawerTitle>
          <div
            style={
              {
                // 修改图标颜色
                '--color': '#000',
              } as CSSProperties
            }
          >
            <CloseIcon className=" cursor-pointer" color="#000" onClick={() => onOpenChange?.(false)} />
          </div>
        </DrawerHeader>
        <DrawerBody className="py-5">{children}</DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
